/* global euAdminConfig */

import _t from '../modules/translations';

const initialize = () => {
    const membersSelector = '.member_checkbox-row > div';
    const checkboxesSelector = '.member_checkbox-row [type=checkbox]';
    const externalMemberSelector = '#externalMember';
    const externalMemberAddButtonSelector = '#externalMemberAdd';

    function enableSubmit() {
        document.getElementById('group_form_submit').removeAttribute('disabled');
        document.getElementById('one_group_member_required').style.display = 'none';
    }
    function disableSubmit() {
        document.getElementById('group_form_submit').disabled = true;
        document.getElementById('one_group_member_required').style.display = 'inline';
    }

    function toggleAllMembers(check) {
        document.querySelectorAll(checkboxesSelector).forEach((checkbox) => {
            checkbox.checked = check;
        });
    }

    const checkAllEl = document.getElementById('checkAllMembers');
    checkAllEl.addEventListener('click', () => {
        toggleAllMembers(true);

        const members = document.querySelectorAll(membersSelector);

        if (members && members.length > 0) {
            enableSubmit();
        }
    });

    const uncheckAllEl = document.getElementById('uncheckAllMembers');
    uncheckAllEl.addEventListener('click', () => {
        toggleAllMembers(false);
        disableSubmit();
    });

    function filterMembers(filterText) {
        const members = document.querySelectorAll(membersSelector);
        for (let i = 0; i < members.length; i++) {
            if (members[i].innerText.toLowerCase()
                .includes(filterText.toLowerCase())) {
                members[i].style.display = 'flex';
            } else {
                members[i].style.display = 'none';
            }
        }
    }

    const filterMembersInput = document.getElementById('filterMembers');
    filterMembersInput.addEventListener('input', () => {
        filterMembers(filterMembersInput.value);
    });

    function addNewMember(newMemberEmail) {
        if (!newMemberEmail || !document.querySelector(externalMemberSelector).checkValidity()) {
            alert('valid e-mail is required');

            return;
        }

        const newLoopIndex = document.querySelectorAll(membersSelector).length + 1;
        let template = document.querySelector('#external_member_template').innerHTML;
        template = template.replaceAll('__id__', newLoopIndex);
        const div = document.createElement('div');
        div.innerHTML = template;
        div.querySelector('label').textContent = newMemberEmail;
        div.querySelector('input[name*=email]').value = newMemberEmail;
        div.querySelector('input[name*=email]').value = newMemberEmail;
        div.style.display = 'block';

        document.querySelector('.member_checkbox-row').prepend(div);

        document.querySelector(externalMemberSelector).value = '';
        document.querySelector(externalMemberSelector).focus();

        enableSubmit();
    }

    const externalMemberAdd = document.querySelector(externalMemberAddButtonSelector);
    if (externalMemberAdd) {
        externalMemberAdd.addEventListener('click', () => {
            addNewMember(document.querySelector(externalMemberSelector).value);
        });
    }

    // force checked checkbox button on page load
    const memberCheckBoxes = document.querySelectorAll(checkboxesSelector);
    for (const memberCheckBox of memberCheckBoxes) {
        if (memberCheckBox.hasAttribute('checked')) {
            memberCheckBox.checked = true;
            memberCheckBox.setAttribute('checked', 'checked');
        } else {
            memberCheckBox.checked = false;
            memberCheckBox.removeAttribute('checked');
        }
    }

    const memberRow = document.querySelector('.member_checkbox-row');

    memberRow.addEventListener('change', (event) => {
        if (event.target.classList.contains('form-check-input')) {
            const memberChecked = document.querySelectorAll(`${checkboxesSelector}:checked`);
            if (memberChecked.length > euAdminConfig.maxGroupSize) {
                event.target.checked = false;
                alert(_t('groups.max_group_size'));
            }
            if (memberChecked.length > 0) {
                enableSubmit();
            } else {
                disableSubmit();
            }
        }
    });
};

export default initialize;
